// <auto-generated>
// This file is automatically generated from DSL.
// Source: dsl/entities/PlanLineReevaluationRun.yaml
// Generated: 2026-09-03T08:07:34.059Z
// </auto-generated>

import { EntityService } from '@/lib/EntityService';
import { CreatePlanLineReevaluationRun, UpdatePlanLineReevaluationRun, PlanLineReevaluationRun } from '@/types/finance/PlanLineReevaluationRun';

/**
 * PlanLineReevaluationRun Service
 * CRUD operations for PlanLineReevaluationRun via the ABP API.
 */
export const planLineReevaluationRunService = new EntityService<PlanLineReevaluationRun, CreatePlanLineReevaluationRun, UpdatePlanLineReevaluationRun>(
  '/api/finance/planlinereevaluationrun',
  'PlanLineReevaluationRun',
);
